<template>
  <v-container
    fluid
    class="ma-0 pa-6 pt-0 pb-0"
  >
    <v-row>
      <v-col class="shrink hidden-xs-and-down pe-0">
        <v-avatar
          size="35"
          class="ma-0"
        >
          <img
            :src="userAvatar"
            alt="avatar"
          >
        </v-avatar>
      </v-col>
      <v-col class="grow">
        <v-card
          class="pa-2 ps-3 pe-3 note-card"
          :color="isMyNote ? 'grey lighten-4' : 'grey lighten-4' "
          flat
        >
          <h4>
            {{ noteUser ? noteUser.name : note.username }}
            <span class="grey--text font-weight-regular pl-1 pr-1">{{ time }}</span>
          </h4>
          <vue-markdown :source="note.text"></vue-markdown>
          <v-menu
            bottom
            right
            v-if="isMyNote || isAdmin"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                small
                icon
                text
                v-on="on"
                class="note-menu"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-for="(item, i) in menuItems"
                :key="i"
                @click="envokeMethodByName(item.click)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { format } from "date-fns";
import colors from "vuetify/es5/util/colors";
import { camelCase } from "lodash";
import VueMarkdown from "vue-markdown-v2";

export default {
  data() {
    return {
      removing: false,
      menuItems: [
        {
          title: "עריכה",
          click: "edit"
        },
        {
          title: "מחיקה",
          click: "remove"
        }
      ]
    };
  },

  computed: {
    isMyNote() {
      let userId = this.note.user ? this.note.user._id || this.note.user : null;
      return this.user._id === userId;
    },
    isAdmin() {
      return false;
    },
    noteUser() {
      if (this.note.user) {
        return this.$store.state.entities.users[this.note.user];
      }
      return null;
    },
    userAvatar() {
      if (this.noteUser) {
        if (this.noteUser.image) {
          return this.noteUser.image;
        } else {
          return `https://ui-avatars.com/api/?name=${this.userAvatarName}&background=${this.userAvatarColor}&size=80&color=ffffff&rounded=1&length=1`;
        }
      }
      return null;
    },
    userAvatarName() {
      return this.noteUser ? this.noteUser.name : null;
    },
    userAvatarColor() {
      if (this.noteUser) {
        let color = this.noteUser.color;
        if (color) {
          color = camelCase(color);
        } else {
          color = "blue";
        }
        return colors[color].base.substr(1);
      } else {
        return null;
      }
    },
    user() {
      return this.$store.getters["user/user"];
    },
    time() {
      return this.heDate(this.note.created) + ' ' + format(new Date(this.note.created), "HH:mm");
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
  },

  methods: {
    envokeMethodByName(name) {
      this[name]();
    },
    heDate(d) {
      let date = new Date(d);
      let options = { weekday: "long", month: "long", day: "numeric" };
      return new Intl.DateTimeFormat("he-IL", options).format(date);
    },
    edit() {
      this.editNote(this.note);
    },
    editNote(entity, isNew = false) {
      let resource = this.$store.state.resources.note;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew
      });
      this.entityEditDialog = true;
    },
    remove() {
      this.removeNote(this.note);
    },
    removeNote(note) {
      this.$root.$confirm("האם למחוק את ההערה?").then(res => {
        if (!res) {
          return;
        }

        this.removing = true;
        this.$store
          .dispatch("REMOVE_ENTITY", {
            url: "/notes",
            entityType: "notes",
            id: note._id
          })
          .then(() => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: "ההערה נמחקה",
              color: "success"
            });
          })
          .catch(err => {
            console.log(err.stack);
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: err.message,
              color: "error"
            });
          })
          .finally(() => {
            this.removing = false;
          });
      });
    }
  },

  components: {
    VueMarkdown
  },

  props: ["note"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.note-card {
  border-radius: 15px;

  h4 {
    margin-left: 50px;
  }
}

p {
  margin-bottom: 0px !important;
}
</style>

<style lang="scss">
.note-menu {
  position: absolute !important;
  top: 0;
  left: 0;
}

.note-card {
  p {
    margin-bottom: 0px !important;
    word-break: break-word;
  }
}
</style>